import images from "../../../../utils/images";
import React from "react";
import { withRouter } from "react-router-dom";
import { Main2 } from "@/ui2/atoms/Main";

const EditNoteWrapper = (props) => {
  const { patient, note, noteDraftSubmitHandler, noteSubmitHandler } = props;
  const patientData = `${patient.first_name} ${patient.last_name} (Date of Birth : ${patient.dob})`;
  return (
    <Main2>
      <section className="tw:!flex tw:flex-col tw:items-center">
        <div className="survey-back-link-wpr mr-auto tw:mt-5 fs-16">
          <span className="survey-back-link" onClick={() => props.history.go(-1)}>
            <img className="img-fluid" src={images("./common/solidBckBtn.svg")} />
            <p className="d-inline ml-2">Back to Patient Profile</p>
          </span>
        </div>

        <strong>{patientData}</strong>
        <strong>{note.title}</strong>
      </section>

      {props.children}

      <div className="d-flex tw:justify-center my-3 mx-auto w-25">
        <div className="position-relative w-100 text-center">
          <button
            className="GuidedVideoCall__center-btn fs-14"
            style={{ backgroundColor: "#5B57DC" }}
            onClick={() => noteDraftSubmitHandler()}
          >
            Save Draft
          </button>
        </div>

        <div className="position-relative w-100 text-center">
          <button className="GuidedVideoCall__center-btn fs-14" onClick={() => noteSubmitHandler()}>
            Sign & Submit
          </button>
        </div>
      </div>
    </Main2>
  );
};

export default withRouter(EditNoteWrapper);
